import React, { useEffect } from "react";

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,  
  Button
} from "reactstrap";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import ConcessionariasForm from '../../../views/admin/cadastros/ConcessionariasForm.jsx';

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";


export default function ConcessionariasList({history}) {    
  const [list_table, set_list_table] = React.useState([])
  const[list_loading, set_list_loading] = React.useState(false);
  
  const[showDetail, setshowDetail] = React.useState(false);
  const[itemDetail, setitemDetail] = React.useState(null);
  
  const GetList = () => {    
    set_list_loading(true);

    api_GET('concessionaria').then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else{
        set_list_table(result.data);
      }
    });
  }

  const Edit = (event, rowData) => {    
    setitemDetail(rowData);
    setshowDetail(true);    
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);    
  };

  const handleReturn = (item) => {
    let list;
    if (item != null)
    {
        list = list_table.filter(f => f.concessionariaId != item.concessionariaId);
        list.push(item);
    }
    else
      list = list_table;

    set_list_table(list);
    setshowDetail(false);
    setitemDetail(null);    
  }

  useEffect(() => {
    GetList();
  }, []);

  const columnsProp = [
    { title: 'Identificação', field: 'identificacao' },
    { title: 'CNPJ', field: 'cnpj' },
    { title: 'Contato', field: 'contato' },
    { title: 'Status', field: 'ativo', render: (rowData) => rowData.ativo == true ? "Ativo" : "Inativo" },      
  ]  

  return (
    <>
        <Header />
        <Container className="mt--9" fluid>

          {!showDetail &&
            <Row>
              <Container className="mt-1" fluid>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                        <Col md="6">
                          <strong> Concessionárias</strong>
                        </Col>
                        <Col md="6" className="text-right">                              
                          <Button color="primary" type="submit" onClick={() => Add()}>
                              <FontAwesomeIcon icon={faPlus} />  Nova Concessionária
                          </Button>
                        </Col>
                      </Row>                          
                  </CardHeader>  
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <MaterialTable
                            title="Lista de Concessionárias"
                            columns={columnsProp}
                            data={list_table}
                            isLoading={list_loading}
                            options={table_style}
                            actions={[
                              {
                                icon: 'edit',
                                tooltip: 'Editar Registro',
                                onClick: (event, rowData) => Edit(event, rowData)
                              }
                            ]}
                            localization={table_translate}  
                          />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>                  
              </Container>
            </Row>
          }          
          
          {showDetail && 
            <ConcessionariasForm handleReturn={handleReturn} item={itemDetail}></ConcessionariasForm>
          }

        </Container>        

    </>
  );
}
